import React, { useRef, useState } from 'react';
import Menu from './Menu';
import HeaderContents from './HeaderContents';
import { useSelector } from 'react-redux';
import { State } from '../../redux/state';
import '../../styles/common/header.scss';

const BlogHeader = (props: any) => {
  const ref = useRef<HTMLDivElement>(null);
  const [menuActive, setMenuActive] = useState(false);
  const hideMenu: boolean = useSelector((state: State) => state.hideMenu);

  return (
    <section className="header">
      <Menu menuActive={menuActive} setMenuActive={setMenuActive} blog={true} />
      <div className="header-left">
        <a href="/">
          <div className="header-left_logo">
            <img src={`${IMAGE_PATH}images/logo_main.png`} alt="" />
          </div>
        </a>
      </div>
      <div className="header-right">
        {!hideMenu && (
          <HeaderContents
            setMenuActive={setMenuActive}
            date={props.date}
            lightTheme={false}
            ref={ref}
          />
        )}
      </div>
    </section>
  );
};

export default BlogHeader;
